import {MovieLayer} from 'common/src/modules/movie/movieLayers.types';

// When pasting a layer we want it to have a unique name. we add a number to that element
// example: If i have a  new layer called 'abc' and a layer with the same name already exists, the new one will be called 'abc 2'.
// now,after adding the new element if I paste another layer called 'abc' or 'abc 2' I want it to be renamed to 'abc 3'
// idxOfCopiedLayer - when duplicating several layers, we add the number of this layer to the new layer name
export function getLayerWithUniqueName(
  layers: MovieLayer[],
  newElementName: string,
  idxOfCopiedLayer: number,
) {
  // Define a regex to extract the base name and suffix number if they exist
  const regex = /(.*?)(?: (\d+))?$/;
  const match = regex.exec(newElementName);

  const baseName = match?.[1] || '';
  let maxNumber = match?.[2] ? parseInt(match?.[2] || '1') : 1;
  let nameExists = false;

  layers.forEach((layer) => {
    const layerMatch = regex.exec(layer.name);
    const elementBaseName = layerMatch?.[1] || '';
    const elementNumber = layerMatch?.[2] ? parseInt(layerMatch?.[2] || '1') : 1;

    if (elementBaseName === baseName && elementNumber >= maxNumber) {
      nameExists = true;
      maxNumber = elementNumber + 1;
    }
  });

  return nameExists ? `${baseName} ${maxNumber + idxOfCopiedLayer}` : newElementName;
}
